export default __webpack_public_path__ + "static/media/Group 7350.5cf258c1.svg";